import { render, staticRenderFns } from "./ProductTable.vue?vue&type=template&id=47ca76f7"
import script from "./ProductTable.vue?vue&type=script&lang=ts"
export * from "./ProductTable.vue?vue&type=script&lang=ts"
import style0 from "./ProductTable.vue?vue&type=style&index=0&id=47ca76f7&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports